export function UPDATE_USER_INFO(state, data) {
    state.userInfo = data
}
export function UPDATE_ORDER_INFO(state, data) {
    state.orderInfo = data
}
export function QUICK_ORDER (state, data) {
    state.hasQuickOrder = data
}

export function ADD_LABEL(state, data) {
    if (state.labelList.indexOf(data) === -1) {
        state.labelList.push(data)
    }
}

export function REMOVE_LABEL(state, data) {
    const index = state.labelList.indexOf(data)
    state.labelList.splice(index, 1)
}

export function SET_OPEN_KEYS(state, data) {
    state.openKeys = data
}

export function SET_SELECTED_KEYS(state, data) {
    state.selectedKeys = data
}
export function SET_COMPANY_LIST(state, data) {
    state.companyList = data
}
export function SET_ADDRESS_LIST(state, data) {
    state.addressList = data
}
export function UPDATE_DISPATCH_LIST(state, data) {
    state.DispatchList = data
}
export function UPDATE_COLLECTION_DATA(state, data) {
    state.collectionsTopArray = data
}
export function IS_LOGGE_IN(state, data) {
    state.isLoggedIn = data
}


export function CLEAR_VUEX(state) {
    state.userInfo = null // 用户信息
    state.labelList = [] // 页签数据
    state.menuList = []
    state.openKeys = [] // 展开菜单
    state.selectedKeys = [] // 选中菜单
    state.companyList = []
    state.addressList = []
    state.orderInfo = []
    state.hasQuickOrder = null
    state.collectionsTopArray = []
    state.isLoggedIn = false
}